import { useContext, useEffect, useState } from "react";
import { User_Service } from "../../services/user/user-service";
import { PERMISSIONS } from "../../utils/constants";
import SyncSingleUserAttendance from "../attendance/SyncSingleUserAttendance";
import MultiPermissionAuthorize from "../MultiPermissionAuthorize";
import New_Item from "../new-item";
import { RUDTable } from "../Table/RUDTable";
import UserContext, { User_Type } from "../UserContext";
import SingleUserSync from "./SingleUserSync";

const initial_filter = {
    org_code: "",
    org_api_key: "",
    search: "",
    branch: "",
    apply: 0,
    verfied: "",
};

const TodaySyncUsers = () => {
    const [filter, set_filter] = useState(initial_filter);
    const [refetchCount, setRefetchCount] = useState(0);
    const [selectedRows, setSelectedRows] = useState<any>();

    const { user } = useContext(UserContext);

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            set_filter((f) => ({
                ...f,
                org_code: user.organization.code,
                org_api_key: user.organization.apiKey[0].key,
            }));
        }
    }, [user?.user_type]);
    return (
        <div>
            <MultiPermissionAuthorize ops={[PERMISSIONS.CREATE_USER]}>
                <New_Item title="Sync Single User">
                    <SingleUserSync />
                </New_Item>
            </MultiPermissionAuthorize>

            <RUDTable
                storageKey="Today-sync-users"
                updatingAgents={[filter.org_code, filter.org_api_key]}
                getter={(page, limit) =>
                    User_Service.get_instance().get_users(
                        filter.org_code,
                        filter.org_api_key,
                        {
                            page,
                            limit,
                            search: filter.search ? filter.search : undefined,
                            branch: filter.branch ? filter.branch : undefined,
                            verfied: filter.verfied
                                ? filter.verfied
                                : undefined,
                            today: true,
                        }
                    )
                }
                deletor={(id, row) => {
                    return User_Service.get_instance().delete_user(
                        row?.branch?.id,
                        row.id,
                        row.pin,
                        filter.org_code,
                        filter.org_api_key
                    );
                }}
                editor={(...args) => {
                    const [id, changes, row] = args;
                    return User_Service.get_instance().update_user(
                        row.branch.id,
                        row.pin,
                        filter.org_code,
                        changes,
                        filter.org_api_key
                    );
                }}
                rowsPreprocessor={(row) => ({
                    ...row,
                    id: row.id,
                    deletionId: row.pin,
                })}
                ops={{
                    read: PERMISSIONS.READ_USER,
                    edit: "No edit",
                    delete: "no delete",
                }}
                readables={{
                    id: "ID",
                    name: "Name",
                    pin: "PIN",
                    "Sync Attendance": "Sync Attendance",
                    
                }}
                editables={[]}
                customCols={[
                    {
                        header: "Sync Attendance",
                        content: (row) => (
                            <SyncSingleUserAttendance
                                rows={[row]}
                                disabled={false}
                                onSuccess={() => {
                                    setRefetchCount((n) => n + 1);
                                }}
                            />
                        ),
                    },
                ]}
                getSelectedRows={(rows) => {
                    setSelectedRows(rows);
                }}
            />
        </div>
    );
};

export default TodaySyncUsers;
